import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=56645ef3&scoped=true&"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthentication.vue?vue&type=style&index=0&id=56645ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56645ef3",
  null
  
)

export default component.exports